export default __webpack_public_path__ + "static/media/2.cee278c9.png";